"use client";

import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { PrimaryButton } from "@nib-components/button";
import { NibbyHappySystemIcon } from "@nib-group/chatbot-shared/icons";
import { belowMeshMdBreakpoint } from "@nib-group/chatbot-shared/mesh/breakpoint";
const Button = styled(PrimaryButton)({
  // Visuals
  transition: "box-shadow 300ms, transform 300ms",
  transitionTimingFunction: "cubic-bezier(.19, 1, .22, 1)",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  "&&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)"
  },
  [belowMeshMdBreakpoint]: {
    // Box model
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 50,
    width: 50,
    padding: 0,
    span: {
      display: "none"
    },
    // Columns contributes some rather frustrating additional margins when only
    // displaying an icon
    '[data-mesh-component="COLUMNS"]': {
      margin: 0
    }
  }
});
export const ChatButton = _ref => {
  let {
    id,
    onClick
  } = _ref;
  return _jsx(Button, {
    icon: NibbyHappySystemIcon,
    iconPlacement: "left",
    onClick: onClick,
    id: id,
    "data-testid": id,
    "aria-label": "Start a live chat with us",
    children: _jsx("span", {
      children: "Chat now"
    })
  });
};